<template>
  <div>
    <div v-if="cartList.length" class="selection notranslate">
      <span class="checkbox">
        <input type="checkbox" id="cart_check_all_top"
          v-model="checkedAll"
          @change="isCheckedAll">
        <label for="cart_check_all_top">{{locale.all}}</label>
      </span>
      <button type="button" class="btn btnRound sizeXs btnWhite toCapitalize" @click="deleteItem(checkedIds)">{{locale.delete}}</button>
    </div>
    <div class="list"
      :class="{multiCart: multiCart}">
      <div v-if="cartList.length">
        <div v-for="item in cartList"
          :key="item.cartId">
          <CartItemAmenity
            v-if="item.cartId.includes('amenity')"
            :lang="lang"
            :item="item"
            :locale="locale"
            :change="change"
            :multiCartAvailable="multiCartAvailable(item)"
            :setting="amenitySetting"
            :class="{first: item.first, last: item.last}"
            :multiCartTax="taxPrice(item.submitId)"
            @checkedItem="checkedItem"
            @requestMultiCart="requestMultiCart"
            @deleteAmenity="deleteAmenity" />
          <CartItem
            v-else
            :lang="lang"
            :item="item"
            :locale="locale"
            :change="change"
            :multiCartAvailable="multiCartAvailable(item)"
            :submitCode="submitCode"
            :class="{first: item.first, last: item.last}"
            :multiCartTax="taxPrice(item.submitId)"
            @checkedItem="checkedItem"
            @requestMultiCart="requestMultiCart"
            @delete="deleteItem" />
        </div>
      </div>
      <div v-else class="cartItem noData notranslate">{{locale.cart_empty}}</div>
    </div>
    <div v-if="!multiCart && list.length" class="cartTotal notranslate">
      <div v-if="totalPrice" class="toCapitalize">
        <div v-if="taxPrice()">
          <div class="tax price">
            <span class="label">{{locale.subtotal}}</span>
            <span class="value">{{priceFormat(taxPrice().subtotal)}}</span>
          </div>
          <div class="tax price">
            <span class="label">{{locale.tax}}({{taxPrice().taxLabel}})</span>
            <span class="value">{{priceFormat(taxPrice().tax)}}</span>
          </div>
          <div class="price mb30">
            <span class="label">{{locale.total}}</span>
            <span class="value">{{priceFormat(taxPrice().total)}}</span>
          </div>
        </div>
        <div v-else class="price mb30">
          <span class="label">{{locale.total}}</span>
          <span class="value">{{priceFormat(totalPrice())}}</span>
        </div>
      </div>
      <div v-if="!isAuth" class="messages">
        <p v-if="!isAuth" class="validateMessage">{{locale.invalid_key}}</p>
      </div>
      <div class="btns">
        <button v-if="!possibleAmenity.isPossible"
          type="button"
          class="btn btnRound toCapitalize"
          disabled
          @click.stop="requestCart">
          {{locale.btn_request}}
        </button>
        <button v-else
          type="button"
          class="btn btnRound toCapitalize"
          :disabled="!checkedIds.length || !isAuth"
          @click.stop="requestCart">
          {{confirmChanged ? locale.next_step : locale.btn_request}}
          </button>
      </div>
    </div>
    <UserInfo v-if="paymentUserInfo"
      :lang="lang"
      :locale="locale"
      :submitId="multicartSubmitId"
      @confirm="confirmPaymentUserInfo" />
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import CartItem from '@/components/Cart/CartItem.vue'
import CartItemAmenity from '@/components/Cart/CartItemAmenity.vue'
import UserInfo from '@/components/Payment/UserInfo.vue'
import Toast from '@/components/Util/Toast'

export default {
  name: 'CartList',
  props: [
    'lang',
    'locale',
    'isPublic'
  ],
  components: {
    CartItem,
    CartItemAmenity,
    UserInfo,
    Toast
  },
  computed: {
    ...mapGetters({
      getTax: 'payment/getTax',
      getAvailableDay: 'util/getAvailableDay'
    }),
    setting () {
      return this.$store.getters['common/getSetting']
    },
    tax () {
      return this.$store.state.payment.tax
    },
    multiCart () {
      return this.setting.order && this.setting.order.multiCart
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    currencyCode () {
      return this.setting.currency.toUpperCase()
    },
    checkableIds () {
      const site = this.$store.state.authentication.site
      const amenity = `cart_${site}_amenity`
      return this.cartList.filter(x => x.cartId === amenity || (x.isAvailable && x.isOpen)).map(x => x.cartId)
    },
    checkedIds () {
      return this.cartList.filter(x => x.isChecked).map(x => x.cartId)
    },
    cartList () {
      // return this.list.filter(x => !(x.removed))
      function getMultiCartPrice (arr, id) {
        return arr.filter(x => (x.submitId === id) && x.price && x.price.info && x.price.info.total && x.isChecked)
          .map(x => x.price.info.tax ? x.price.info.subtotal : x.price.info.total)
          .reduce((a, b) => a + b, 0)
      }
      let list = this._.cloneDeep(this.list)
      const isMultiCart = this.multiCart
      if (isMultiCart) {
        list = list.sort((a, b) => {
          return a.submitId < b.submitId ? -1 : a.submitId > b.submitId ? 1 : 0
        }).map((x, i) => {
          const b = list[i + 1]
          const c = list[i - 1]
          const submitId = x.submitId
          if (!b || (b && submitId !== b.submitId)) {
            x.last = true
            // x.multiCartAvailable = list.filter(d => d.submitId !== 'system_amenity' && d.submitId === submitId).filter(d => !d.isAvailable).length === 0
            // x.multiCartOpen = list.filter(d => d.submitId !== 'system_amenity' && d.submitId === submitId).filter(d => !d.isOpen).length === 0
            x.multiCartPrice = getMultiCartPrice(this.list, x.submitId)
          }
          if (!c || (c && submitId !== c.submitId)) {
            x.first = true
          }
          return x
        })
      }
      return list
    },
    priceInfo () {
      return (submitId) => this.cartList
        .filter(x => submitId
          ? x.isChecked && x.submitId === submitId && x.price && x.price.info !== null
          : x.isChecked && x.price && x.price.info !== null)
        .map(x => {
          return {
            ...x.price.info,
            quantity: x.changedInfo && x.changedInfo.qty > 0 ? x.changedInfo.qty : x.price.info.quantity,
            total: x.changedInfo && x.changedInfo.total > 0 ? x.changedInfo.total : x.price.info.total
          }
        })
    },
    totalPrice () {
      return (submitId) => {
        const isChange = this.change
        const checked = this.checkedIds
        const price = this.cartList.filter(x => checked.includes(x.cartId))
          .filter(x => submitId
            ? x.submitId === submitId && x.price && x.price.info !== null
            : x.price && x.price.info !== 0)
          .map(x => {
            return isChange && x.changedInfo
              ? x.changedInfo.total
              : x.price.info.tax
                ? x.price.info.subtotal
                : x.price.info.total
          })
        const sum = (accumulator, currentValue) => accumulator + currentValue
        const total = price && price.length ? price.reduce(sum) : 0
        return price.length ? total : 0
      }
    },
    taxPrice () {
      return (submitId) => {
        const total = this.totalPrice(submitId)
        const taxPer = this.tax
        const tax = this.getTax(total)
        const taxTotal = total + tax
        return taxPer
          ? {
            subtotal: total,
            tax: tax,
            taxLabel: `${taxPer}%`,
            total: taxTotal
          }
          : null
      }
    },
    activeUserInfo () {
      return this.$store.state.common.setting.order && this.$store.state.common.setting.order.disabled !== true
    },
    possibleAmenity () {
      const hasAmenity = this.list.find(x => x.submitId.includes('system_amenity'))
      const checkedAmenity = this.checkedIds.find(x => x.includes('amenity'))
      const setting = this.amenitySetting
      const itemLimit = setting && setting.itemLimitActive && setting.itemLimit
      const validItems = hasAmenity
        ? hasAmenity.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length
        : 0
      return {
        hasAmenity: hasAmenity,
        checkedAmenity: checkedAmenity,
        validItems: validItems,
        isPossible: hasAmenity && checkedAmenity && setting
          ? itemLimit
            ? itemLimit >= validItems
            : true
          : true,
        itemLimit: hasAmenity && setting
          ? itemLimit
          : null
      }
    },
    isUserinfo () {
      const inputs = this.$store.getters['common/getUserinfo']
      const isFirstName = inputs.firstName !== false
      const isLastName = inputs.lastName !== false
      const isTel = inputs.tel !== false
      const isEmail = inputs.email !== false
      const isCustom = inputs.custom && inputs.custom.length > 0
      return isFirstName || isLastName || isTel || isEmail || isCustom
    }
  },
  async mounted () {
    const site = this.$store.state.authentication.site
    this.$store.commit('loading', true)
    await this.getKey()
    await this.$store.dispatch('submit/getSystemCode').then((sysCode) => {
      this.$store.dispatch('submit/getUserCode').then((userCode) => {
        if (sysCode) {
          this.submitCode = this.submitCode.concat(sysCode)
        }
        if (userCode) {
          this.submitCode = this.submitCode.concat(userCode)
        }
      })
    })
    if (localStorage.length > 0) {
      for (let i = 0; i < localStorage.length; i++) {
        // cart_로 시작하는 items
        const storage = localStorage.key(i)
        if (storage.includes('cart_') && storage.includes(site)) {
          const cartItem = JSON.parse(localStorage.getItem(storage))
          let item = Object.assign({}, cartItem)
          item.cartId = localStorage.key(i)
          // 이용가능 시간 다시 불러옴
          if (item.pageId) {
            await this.$store.dispatch('page/loadPage', item.pageId).then((res) => {
              if (res.id) {
                item.isOpen = res.state === '01'
                item.info.available = res.available
                item.isChecked = this.checkAvailableTime(res.available)
                item.isAvailable = this.checkAvailableTime(res.available)
                item.isExist
              } else {
                item.removed = true
              }
            })
          }
          if (item.productId) {
            item.isOpen = true
            // item.isChecked = this.checkAvailable(item.info.available) && item.price.info.quantity && item.price.info.quantity > 0
            // item.isAvailable = this.checkAvailable(item.info.available)
          }
          if (cartItem.content) {
            cartItem.content.forEach(function (x) {
              if (x.type === 'datetime') {
                item.datetime = x
              } else if (x.type === 'quantity') {
                item.quantity = x
              }
            })
          }
          if (item.content) {
            item.content = cartItem.content.filter(x => {
              return x.type !== 'datetime' && x.type !== 'quantity' && x.value !== null
            })
          }
          if (item.cartId === `cart_${site}_amenity`) {
            // 요청한 어메니티 히스토리 (제한이 있는 경우를 위한 정보 호출)
            await this.diffAmenity(item).then((res) => {
              this.checkOrderedAmenity(item).then((cartContent) => {
                // if (cartContent.items.length <= 0) {
                //   localStorage.removeItem(`cart_${site}_amenity`)
                // } else {
                //   localStorage.setItem(`cart_${site}_amenity`, JSON.stringify(cartContent))
                // }
              })
            })
          }
          // 게스트타입 추가변동금액 적용
          if (item.guestTypePrice) {
            item.price.info = {
              ...item.price.info,
              price: item.productId // price: 단가, 페이지는 0일 수도 있음
                ? item.guestTypePrice.normalPrice
                : item.price.info.price,
              total: item.guestTypePrice.total
            }
          }
          if (item.productId && (item.productId.includes('undefined') || item.removed)) {
            localStorage.removeItem(storage)
            this.$store.commit('cart/delList', item.cartId)
          } else {
            this.$store.commit('cart/addList', item)
            this.list.push(item)
          }
        }
        if (i === localStorage.length - 1) {
          this.list.sort((a, b) => parseFloat(Number(b.order)) - parseFloat(Number(a.order)))
          this.diffManageProduct()
          this.loadProduct()
        }
      }
    }
    this.$store.commit('loading', false)
  },
  data () {
    return {
      list: [],
      checkedAll: true,
      payment: null,
      confirmChanged: false,
      manageList: [],
      change: false,
      paymentUserInfo: null,
      submitCode: [],
      amenitySetting: {},
      isAuth: false,
      key: this.$store.state.authentication.k,
      checkAvailable: 0,
      multicartSubmitId: null,
      toastList: []
    }
  },
  methods: {
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
      this.checkAuth()
    },
    checkAuth () {
      const getAuthInfo = this.$store.getters['authentication/getAuthInfo']
      const key = this.key
      const space = getAuthInfo.space
      const hasKey = !!key && key !== 'undefined'
      const hasSpace = !!space && space !== 'undefined'
      const isKeyValid = !(getAuthInfo.otavalid && getAuthInfo.otavalid === 'false')
      this.isAuth = hasKey && hasSpace && isKeyValid
    },
    isCheckedAll () {
      const isCheckedAll = this.checkedAll
      const checkableIds = this.checkableIds
      this.list = this.list.map(x => {
        const checked = !x.isAvailable ? false : isCheckedAll && checkableIds.includes(x.cartId) && !x.isDisabled
        return {
          ...x,
          isChecked: checked
        }
      })
    },
    checkAvailableTime (data) {
      let isAvailable = true
      const available = data // submit 데이터
      const isAlways = available.state === '01' // 01 ? always : each
      const today = moment().isoWeekday() - 1
      const day = available.set[today]
      const check = this.getAvailableDay(day)
      isAvailable = isAlways
        ? true
        : check
      return isAvailable
    },
    get1dayOrders (iso) {
      const timezone = this.timezone
      const time = this.amenitySetting.limitTime || '12:00' // 설정한 리셋시간
      const hh = time.split(':')[0]
      const mm = time.split(':')[1]
      const today = moment().set({ hour: hh, moment: mm, second: 0 }).tz(timezone).toISOString()
      const tomorrow = moment().set({ hour: hh, moment: mm, second: 0 }).add(1, 'days').tz(timezone).toISOString()
      return moment(iso).tz(timezone).isBetween(today, tomorrow)
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    displayPrice (price) {
      const currency = this.$store.state.common.setting.currencyEntity
      return `${currency} ${regExp.comma(price)}`
    },
    deleteItem (cartIds) {
      this.addToast('deleteCartItem', 'confirm', this.locale.confirm_cart_delete, { otherData: { cartIds: cartIds } })
    },
    deleteCartItem (cartIds) {
      this.deleteCart(cartIds)
    },
    deleteAmenity (raCode) {
      this.addToast('deleteAmenityItem', 'confirm', this.locale.confirm_cart_delete, { otherData: { raCode: raCode } })
    },
    deleteAmenityItem (raCode) {
      this.deleteCartAmenity(raCode)
    },
    deleteCartAmenity (raCode) {
      const Store = this.$store
      const siteId = Store.state.authentication.site
      const cartId = `cart_${siteId}_amenity`
      const cartAmenity = this.list.find(x => x.cartId === cartId)
      if (cartAmenity.items.length > 0 || (cartAmenity.content && cartAmenity.content.length > 0)) {
        cartAmenity.items = cartAmenity.items.filter(x => x.item !== raCode)
        if (cartAmenity.content) {
          cartAmenity.content = cartAmenity.content.filter(x => x.label !== raCode)
        }
        if (cartAmenity.price) {
          const items = cartAmenity.items.filter(x => x.price)
          const total = items && items.length ? items.map(x => x.price * x.count).reduce((a, b) => a + b) : 0
          cartAmenity.price = {
            info: {
              ...cartAmenity.price.info,
              sum: total,
              total: total
            },
            option: items
          }
        }
        localStorage.setItem(cartId, JSON.stringify(cartAmenity))
        if (cartAmenity.items.length === 0 || (cartAmenity.content && cartAmenity.content.length === 0)) {
          this.list = this.list.filter(x => x.cartId !== cartId)
          localStorage.removeItem(cartId)
        }
      } else {
        this.list = this.list.filter(x => x.cartId !== cartId)
        localStorage.removeItem(cartId)
      }
      Store.commit('cart/delAmenity', raCode)
      this.addToast('closeToast', 'alert', this.locale.complete_delete)
    },
    deleteCart (cartIds) {
      const Store = this.$store
      cartIds.forEach(function (cartId, index) {
        localStorage.removeItem(cartId)
        Store.commit('cart/delList', cartId)
        return index + 1 === cartIds.length
      })
      this.list = this.list.filter(x => !cartIds.includes(x.cartId))
      this.checkedAll = false
      this.addToast('closeToast', 'alert', this.locale.complete_delete)
    },
    async checkOrderedAmenity (item) {
      const cartContent = {
        ...item,
        items: item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            ...x.price && {
              price: x.price,
              quantity: x.quantity
            }
          }
        })
      }
      return cartContent
    },
    // 장바구니 리스트 최종 체크
    checkExistItem () {
      this.list.forEach(function(item, index, object) {
        // if (!item.isExist) {
        //   object.splice(index, 1)
        //   localStorage.removeItem(item.cartId)
        //   this.$store.commit('cart/delList', item.cartId)
        // }
      })
    },
    async loadProduct () {
      const products = new Set(this.list.filter(x => x.productId && x.productItemId).map(x => x.productId))
      const productIds = [...products]
      for (let i = 0; i < productIds.length; i++) {
        const id = productIds[i]
        const itemIds = this.list.filter(x => x.productItemId && x.productId && x.productId === id).map(x => x.productItemId)
        await this.$store.dispatch('product/getProduct', id).then((res) => {
          for (let j = 0; j < itemIds.length; j++) {
            const itemId = itemIds[j]
            const item = this.list.find(x => x.productId && x.productId === id && x.productItemId === itemId)
            const resItem = res.items.find(x => x.id === itemId)
            if (item && resItem) {
              item.isDisabled = resItem.disabled || !resItem.service || !resItem.submitTo
              item.isChecked = this.checkAvailableTime(resItem.available) && (item.pageId ? true : item.price.info.quantity && item.price.info.quantity > 0) && !item.isDisabled
              item.isAvailable = this.checkAvailableTime(resItem.available)
              item.info.available = resItem.available
              item.isExist = true // 현재 있는 아이템임
            }
          }
        })
        if (i === productIds.length - 1) {
          this.checkExistItem()
        }
      }
    },
    async diffAmenity (item) {
      function getOrderList (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          if (item.ordersheet.length) {
            for (let j = 0; j < item.ordersheet.length; j++) {
              const ordersheet = item.ordersheet[j]
              result.push({ ...ordersheet, date: item.date })
            }
          } else {
            result.push({ ...item.ordersheet, date: item.date })
          }
        }
        return result
      }
      function getCount (max, count) {
        return max - count <= 0 ? 0 : max - count
      }
      let orderedAmenity = null
      await this.$store.dispatch('submit/getOrderHistory').then((oredered) => {
        if (oredered && oredered.orderLog) {
          const orders = oredered.orderLog.filter(x => {
            return x.order_type && x.order_type.includes('system_amenity')
          }).map(x => {
            return {
              ordersheet: x.ordersheet,
              date: x.createat
            }
          })
          orderedAmenity = getOrderList(orders)
        }
      })
      await this.$store.dispatch('amenity/getAmenity').then((res) => {
        const setting = res.setting
        const isIntegration = setting && setting.integration
        const isAvailable = setting && setting.available ? this.checkAvailableTime(setting.available) : true
        this.amenitySetting = setting
        item.items = item.items.map(x => {
          const amenityItem = res.list.find(a => a.raCode === x.item)
          const orderedItems = orderedAmenity ? orderedAmenity.filter(i => {
            return i.items && i.items.length && i.items.find(f => f.item === x.item)
          }) : []
          const itemMax = amenityItem && isIntegration && amenityItem.orderLimitActive && !(x.price && parseFloat(x.price) >= 0) // 요청가능 수량
            ? amenityItem.orderLimit === 'day'
              ? getCount(amenityItem.max, orderedItems.filter(o => this.get1dayOrders(o.date)).map(o => o.items).flat().filter(o => o.item === x.item).map(o => o.count).reduce((a, b) => a + b, 0)) // 1일 제한
              : getCount(amenityItem.max, orderedItems.map(o => o.items).flat().filter(o => o.item === x.item).map(o => o.count).reduce((a, b) => a + b, 0)) // 투숙기간 제한
            : amenityItem.max
          const count = amenityItem // 최종 요청할 수량 조정
            ? x.count > itemMax
              ? itemMax // 어메니티 최대요청수량보다 많을 수 없음
              : x.count
            : x.count
          const countChanged = x.count > itemMax
          const orderCount = amenityItem && isIntegration && amenityItem.orderLimitActive // 요청 가능한 횟수
            ? amenityItem.orderLimit === 'day'
              ? getCount(amenityItem.orderMax, orderedItems.filter(o => this.get1dayOrders(o.date)).length)
              : getCount(amenityItem.orderMax, orderedItems.length)
            : null
          return {
            ...x,
            count: count,
            disabled: amenityItem.disabled || !amenityItem.service, // 일시중단 또는 서비스하지 않음
            ...countChanged && {
              countChanged: true
            },
            ...isIntegration && amenityItem.orderLimitActive && !x.price && {
              orderLimit: amenityItem.orderLimit,
              orderMax: amenityItem.orderMax,
              orderCount: orderCount,
              passedCount: count > 0, // 요청 개수가 유효?
              passedOrder: orderCount > 0 // 요청 횟수가 유효?
            }
          }
        })
        if (isIntegration && item.price) {
          const priceOption = item.items.filter(x => x.price)
          const total = priceOption.length > 0 ? item.items.filter(x => x.price).map(x => x.price * x.count).reduce((a, b) => a + b) : 0
          item.price = {
            info: {
              ...item.price.info,
              sum: total,
              total: total,
              ...this.tax && {
                tax: this.getTax(total),
                subtotal: total,
                total: total + this.getTax(total)
              }
            },
            option: item.items.filter(x => x.price)
          }
        }
        item.isAvailable = item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length > 0 && isAvailable
        item.isChecked = item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length > 0 && isAvailable
        // item.isExist = item.items.filter(x => !x.disabled).length > 0
      })
      return item
    },
    async diffManageProduct (order) { // order: 주문 직전 체크 (isChecked를 마음대로 단정할 수 없음)
      const res = await this.$store.dispatch('product/getManageProduct')
      this.manageList = res
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]
        const pid = item.pId
        const manageItem = this.manageList.find(x => x.pid === pid)
        const infoA = item.price ? item.price.info : null
        const infoB = manageItem
        // 관리상품 처리
        if (item.manage && manageItem) {
          if (infoA.quantity !== infoB.qty) {
            // 재고수량 없음
            if (infoB.qty === 0) {
              item.changedInfo = {
                initQty: infoA.initQuantity || infoA.quantity,
                qty: infoB.qty,
                total: infoB.qty * infoA.price
              }
              item.isChecked = false
            // 재고수량이 신청수량보다 적음
            } else if (infoB.qty < infoA.quantity) {
              item.changedInfo = {
                initQty: infoA.initQuantity || infoA.quantity,
                qty: infoB.qty,
                total: infoB.qty * infoA.price
              }
            // 일시품절이었다가 재고 추가됨
            } else if (infoA.quantity === 0 && infoB.qty > 0) {
              const rQty = infoA.initQuantity < infoB.qty ? infoA.initQuantity : infoB.qty
              const rTotal = infoA.initQuantity < infoB.qty ? infoA.initQuantity * infoA.price : infoB.qty * infoA.price
              item.changedInfo = {
                initQty: infoA.initQuantity || infoA.quantity,
                qty: rQty,
                total: rTotal
              }
            }
          }
          infoB.qty = infoB.qty - (infoA.quantity) > 0 ? infoB.qty - (infoA.quantity) : 0
        }
      }
      if (!this.confirmChanged && this.list.filter(x => x.changedInfo).length) {
        this.addToast('closeToast', 'alert', `${this.locale.product_qty_changed_1}\n${this.locale.product_qty_changed_2}`)
        this.change = true
        // 장바구니 새로고침시 변경된 수량으로 정보 교체
        this.list.forEach(function (xx) {
          if (xx.manage && xx.changedInfo) {
            const cartId = xx.cartId
            const priceInfo = {
              ...xx.price.info,
              quantity: xx.changedInfo.qty,
              initQuantity: xx.changedInfo.initQty,
              total: xx.changedInfo.total
            }
            const cartContent = {
              ...xx,
              price: {
                ...xx.price,
                info: priceInfo
              },
              ...xx.guestTypePrice && {
                guestTypePrice: xx.guestTypePrice
              }
            }
            delete cartContent.changedInfo
            localStorage.setItem(cartId, JSON.stringify(cartContent))
          }
        })
        this.confirmChanged = true
        return true
      } else {
        // 일시품절 상품 체크해제
        this.list = this.list.map(x => {
          return {
            ...x,
            isChecked: x.manage
              ? order ? x.isChecked : x.price.info.quantity > 0 && x.price.info.total > 0
              : order ? x.isChecked : x.submitId.includes('system_amenity')
                ? this.amenitySetting && this.amenitySetting.itemLimitActive
                  ? (x.items.length <= this.amenitySetting.itemLimit) && x.isAvailable
                  : x.items.filter(i => i.passedCount !== false && i.passedOrder !== false).length > 0 && x.isAvailable
                : x.isAvailable
          }
        })
        return false
      }
    },
    requestMultiCart (submitId) {
      this.multicartSubmitId = submitId
      if (submitId === 'system_amenity') {
        this.requestCart(submitId)
      } else {
        this.checkManageProduct(submitId)
      }
    },
    requestCart (submitId) {
      const amenityItem = this.list.find(x => x.submitId === 'system_amenity')
      this.$store.commit('loading', true)
      if (amenityItem) {
        this.diffAmenity(amenityItem).then((res) => {
          const items = res.items.filter(x => !x.disabled).filter(x => {
            return x.orderLimit
              ? x.passedCount && x.passedOrder
              : x.count > 0
          }).length
          const itemLimit = this.possibleAmenity.itemLimit
          const isValid = itemLimit ? itemLimit >= items : items > 0
          this.$store.commit('loading', false)
          if (submitId === 'system_amenity') {
            if (!isValid) {
              this.addToast('closeToast', 'alert', this.locale.alert_invalid_amenity_item)
            } else {
              this.checkManageProduct(submitId)
            }
          } else {
            this.checkManageProduct(submitId)
          }
        })
      } else {
        this.$store.commit('loading', false)
        this.checkManageProduct(submitId)
      }
    },
    // 재고수량 체크
    async checkManageProduct (submitId) {
      if (this.confirmChanged) {
        this.setOutOfStock()
        if (this.activeUserInfo && this.isUserinfo) {
          this.paymentUserInfo = true
        } else {
          this.onSubmit(submitId)
        }
      } else {
        await this.diffManageProduct(true).then((res) => {
          if (res) {
            this.confirmChanged = true
          } else {
            this.setOutOfStock()
            if (this.activeUserInfo && this.isUserinfo) {
              this.paymentUserInfo = true
            } else {
              this.onSubmit(submitId)
            }
          }
        })
      }
    },
    // 수량없는 상품 체크에서 제외
    setOutOfStock () {
      this.list = this.list.map(x => {
        const outOfStock = x.changedInfo && x.changedInfo.qty <= 0
        return {
          ...x,
          isChecked: outOfStock ? false : x.isChecked
        }
      })
    },
    checkedItem (data) {
      const item = this.list.find(x => x.cartId === data.cartId)
      item.isChecked = data.isChecked
    },
    multiCartAvailable (item) {
      const submitId = item.submitId
      if (item.cartId.includes('amenity')) {
        const itemLimit = this.amenitySetting && this.amenitySetting.itemLimitActive && this.amenitySetting.itemLimit
        const items = item.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount && x.passedOrder
            : x.count > 0
        }).length
        return itemLimit ? items > 0 && itemLimit >= items : items > 0
      } else if (item.last) {
        const group = this.cartList.filter(x => x.submitId === submitId)
        const isChecked = group.filter(x => x.isChecked)
        const isDisabled = group.filter(x => x.isChecked && !x.isAvailable)
        return isChecked.length > 0 && isDisabled.length === 0
      } else {
        return null
      }
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'confirmRequest') {
            this.confirmRequest(data.otherData.submitId)
          } else if (trigger === 'deleteCartItem') {
            this.deleteCartItem(data.otherData.cartIds)
          } else if (trigger === 'deleteAmenityItem') {
            this.deleteAmenityItem(data.otherData.raCode)
          } else if (trigger === 'closeToast') {
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    confirmPaymentUserInfo (confirm) {
      const submitId = this.multicartSubmitId
      if (confirm) {
        this.onSubmit(submitId)
      } else {
        this.paymentUserInfo = null
      }
    },
    onSubmit (submitId) {
      const lang = this.lang
      const submitIds = [...new Set(this.cartList.filter(x => x.isChecked).map(x => x.submitId))]
      const submitAmenity = this.cartList.find(x => x.submitId === 'system_amenity' && x.isChecked)
      const submitAmenityList = submitAmenity ? {
        ...submitAmenity,
        items: submitAmenity.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
      } : null
      const submitAmenityV2 = this.cartList.find(x => x.submitId === 'system_amenity_v2' && x.isChecked)
      const submitAmenityV2List = submitAmenityV2
        ? submitAmenityV2.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            label: x.item,
            value: x.count,
            ...x.label && { label: x.label },
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
        : []
      /**
      * 멀티카트로 요청하면 해당 submitId만 묶어서 요청
      * 아닌경우(default) 체크박스
      */
      const submitAmenityItems = submitAmenity ? submitAmenity.items.filter(x => !x.disabled).map(x => {
        return {
          count: x.count,
          item: x.item,
          ...x.price && { price: x.price },
          ...x.quantity && { quantity: x.quantity }
        }
      }) : []
      const submitDataList = this.cartList
        .filter(x => typeof (submitId) === 'string' ? x.submitId === submitId && x.isChecked : x.isChecked)
        .map(x => {
          return x.submitId === 'system_amenity'
            ? submitAmenity
              ? {
                ...submitAmenity,
                items: submitAmenityItems
              }
              : null
            : {
              ...x,
              title: x.title,
              pId: x.pId || null,
              cartId: x.cartId || null,
              pageId: x.pageId || null,
              productId: x.productId || null,
              productItemId: x.productItemId || null,
              submitAt: moment().toISOString(),
              submitId: x.submitId,
              catCode: x.submitId,
              info: x.info,
              categoryLabel: x.categoryLabel || null,
              content: x.submitContent,
              price: {
                ...x.price,
                info: {
                  ...x.price.info,
                  quantity: x.changedInfo ? x.changedInfo.qty : x.price.info.quantity,
                  total: x.changedInfo ? x.changedInfo.total : x.price.info.total
                }
              },
              ...(submitAmenityV2 && x.submitId === 'system_amenity_v2') && {
                content: submitAmenityV2List,
                items: submitAmenityV2List
              },
              ...x.place && {
                place: x.place,
                placeName: x.place[lang]
              },
              ...x.pickup && {
                pickup: x.pickup,
                ...x.pickup === 'auto' && {
                  pickupTime: x.pickupTime
                }
              }
            }
        })
      const submitDataAll = submitIds.map(id => {
        return {
          isArray: true,
          submitId: id,
          submitArr: submitDataList.filter(x => x.submitId === id).concat([submitAmenityList])
        }
      })
      this.paymentUserInfo = null
      this.multicartSubmitId = null
      if (!submitDataAll.filter(x => x.submitArr.length).length) {
        this.addToast('closeToast', 'alert', this.locale.product_request_nodata)
      } else {
        this.addToast('confirmRequest', 'confirm', this.locale.confirm_request, { otherData: { submitId: submitId } })
      }
    },
    confirmRequest (submitId) {
      this.$store.commit('loading', true)
      const lang = this.lang
      const submitIds = [...new Set(this.cartList.map(x => x.submitId))]
      const submitAmenity = this.cartList.find(x => x.submitId === 'system_amenity')
      const submitAmenityList = submitAmenity ? {
        ...submitAmenity,
        items: submitAmenity.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
      } : null
      const submitAmenityV2 = this.cartList.find(x => x.submitId === 'system_amenity_v2')
      const submitAmenityV2List = submitAmenityV2
        ? submitAmenityV2.items.filter(x => !x.disabled).filter(x => {
          return x.orderLimit
            ? x.passedCount !== false && x.passedOrder !== false
            : x.count > 0
        }).map(x => {
          return {
            count: x.count,
            item: x.item,
            label: x.item,
            value: x.count,
            ...x.label && { label: x.label },
            ...x.price && { price: x.price },
            ...x.quantity && { quantity: x.quantity },
            ...x.pid && { pid: x.pid }
          }
        })
        : []
      /**
      * 멀티카트로 요청하면 해당 submitId만 묶어서 요청
      * 아닌경우(default) 체크박스
      */
      const submitAmenityItems = submitAmenity ? submitAmenity.items.filter(x => !x.disabled).map(x => {
        return {
          count: x.count,
          item: x.item,
          ...x.price && { price: x.price },
          ...x.quantity && { quantity: x.quantity }
        }
      }) : []
      const submitDataList = this.cartList
        .filter(x => typeof (submitId) === 'string' ? x.submitId === submitId && x.isChecked : x.isChecked)
        .map(x => {
          /**
           * 상품의 경우 페이지 submit의 옵션에 붙는 pId 데이터와
           * 동일한 구조로 pIdInfo 맵핑
           * (포스로 전달 등을 위해 옵션 pId만 따로 맵핑하여 저장하는 용도)
           */
          const priceInfo = x.price.info
          const pIdItems = (x.productId && !x.pageId) && x.pId && x.pId.length > 0 ? [{
            index: 0,
            label: x.info.subject,
            pId: x.pId,
            pIdActive: true,
            price: x.price.info.price,
            quantity: x.price.info.quantity,
            value: x.info.subject
          }] : []
          const pIdItemsPrices = pIdItemsPrice(pIdItems)
          const pIdInfo = pIdItems.length > 0 // 페이지 submit에는 이미 pIdInfo 데이터가 있기 때문에 override 하지 않음
            ? {
              price: {
                net: priceInfo.total - pIdItemsPrices, // 본 상품 가격
                sum: pIdItemsPrices, // pId items 합계
                total: priceInfo.total, // 총합계
                ...this.tax && {
                  subtotal: priceInfo.subtotal,
                  tax: priceInfo.tax
                }
              },
              items: pIdItems
            } : null
          return x.submitId === 'system_amenity'
            ? submitAmenity
              ? {
                ...submitAmenity,
                items: submitAmenityItems
              }
              : null
            : {
              ...x,
              title: x.title,
              pId: x.pId || null,
              cartId: x.cartId || null,
              pageId: x.pageId || null,
              productId: x.productId || null,
              productItemId: x.productItemId || null,
              submitAt: moment().toISOString(),
              submitId: x.submitId,
              catCode: x.submitId,
              info: x.info,
              categoryLabel: x.categoryLabel || null,
              content: x.submitContent,
              price: {
                ...x.price,
                info: {
                  ...x.price.info,
                  quantity: x.changedInfo ? x.changedInfo.qty : x.price.info.quantity,
                  total: x.changedInfo ? x.changedInfo.total : x.price.info.total
                }
              },
              ...(submitAmenityV2 && x.submitId === 'system_amenity_v2') && {
                content: submitAmenityV2List,
                items: submitAmenityV2List
              },
              ...x.place && {
                place: x.place,
                placeName: x.place[lang]
              },
              ...x.pickup && {
                pickup: x.pickup,
                ...x.pickup === 'auto' && {
                  pickupTime: x.pickupTime
                }
              },
              ...pIdInfo && {
                pIdInfo: pIdInfo,
              }
            }
        })
      const submitDataAll = submitIds.map(id => {
        return {
          isArray: true,
          submitId: id,
          submitArr: submitDataList.filter(x => x.submitId === id).concat([submitAmenityList])
        }
      })
      function pIdItemsPrice (arr) {
        return arr.filter(x => x.price).map(x => {
          const quantity = x.quantity || 1
          const price = x.price || 0
          return price * quantity
        }).reduce((a, b) => a + b, 0)
      }
      this.$store.dispatch('submit/getSubmitCode').then((res) => {
        const systemCode = res[0] || []
        const userCode = res[1] || []
        const submitCode = systemCode.concat(userCode).map(x => x.id)
        const submitData = submitDataList.filter(x => submitCode.includes(x.submitId))
        const isFrame = this.isPublic ? '&frame=false' : ''
        const remainItems = !this.multiCart && submitData.find(x => x.cartId.includes('amenity')) ? `&remainAmenity=true` : ''
        const returnURL = `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}${remainItems}#/${lang}/complete`
        const totalPrice = typeof (submitId) === 'string' ? this.totalPrice(submitId) : this.totalPrice()
        const taxPrice = typeof (submitId) === 'string' ? this.taxPrice(submitId) : this.taxPrice()
        const submit = {
          isArray: true,
          payload: submitData,
          returnURL: returnURL,
          price: {
            info: {
              ...typeof (submitId) === 'string' ? this.priceInfo(submitId) : this.priceInfo(),
              total: totalPrice,
              ...taxPrice
            },
            total: taxPrice && taxPrice.total ? taxPrice.total : totalPrice
          }
        }
        // 삭제되거나 유효하지 않은 전송코드가 있는 경우
        if (submitDataAll.filter(x => !submitCode.includes(x.submitId)).length) {
          // '유효하지 않은 전송코드가 있습니다.\n해당 건을 제외하고 진행합니다.'
          const uncheckedIds = this.cartList.filter(x => x.isChecked && !submitCode.includes(x.submitId)).map(x => x.cartId)
          this.addToast('closeToast', 'alert', `${this.locale.cart_invalid_catcode_1}\n${this.locale.cart_invalid_catcode_2}`)
          this.list = this.list.map(x => {
            return {
              ...x,
              isChecked: !uncheckedIds.includes(x.cartId) ? x.isChecked : false
            }
          })
          this.$store.commit('loading', false)
        }
        this.$store.dispatch('submit/setSubmit', submit).then((res) => {
          /**
           * 결제 연동된 사이트의 경우
           * 결제 프로세스 진행
           */
          if (res && res.status && res.status === 200) {
            // siteInfo.commerce인 경우 결제과정 거친 후 center로 요청
            // 결제중에서도 후불결제(룸차지)를 허용하는 경우 결제방식 선택 페이지로 이동
            const payment = res.payment
            if (payment) {
              const paymentId = res.paymentId
              const routerName = res.roomCharge ? 'paymentStep' : 'payment'
              const cartIds = typeof (submitId) === 'string' ? this.list.filter(x => x.submitId === submitId).map(x => x.cartId) : this.checkedIds
              this.$router.push({
                name: routerName,
                params: {
                  ln: lang,
                  payment: payment,
                  paymentId: paymentId,
                  ...routerName === 'paymentStep' && {
                    cartIds: cartIds
                  }
                }
              })
              this.$store.commit('loading', false)
            } else {
              // center로 바로 요청
              if (submit.payload.find(x => x.cartId.includes('amenity'))) {
                this.$store.dispatch('submit/setSubmit', submitAmenityList)
              }
              this.deleteCart(typeof (submitId) === 'string' ? this.list.filter(x => x.submitId === submitId).map(x => x.cartId) : this.checkedIds)
              this.addToast('closeToast', 'alert', this.locale.complete_request)
              this.$router.push({ name: 'complete', params: { lang: lang } })
              this.$store.commit('loading', false)
            }
          } else {
            if (res.message && res.message.length) {
              if (res.message.includes('Unauthorized')) {
                // 유효하지 않은 인증키입니다.
                alert(this.locale.invalid_key)
                window.location.reload()
              } else if (res.message.includes('amount')) {
                // 결제할 수 없는 금액입니다.
                alert(this.locale.alert_amount_cannot_paid)
              } else if (res.message.includes('currency')) {
                // 지원하지 않는 통화입니다.
                alert(this.locale.alert_currency_not_support)
              } else {
                // 시스템에러가 발생했습니다.
                alert(this.locale.alert_system_error)
              }
            } else {
              // 시스템에러가 발생했습니다.
              alert(this.locale.alert_system_error)
            }
            this.delToast()
            this.$store.commit('loading', false)
          }
          this.$store.commit('loading', false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  justify-content: center;
}
.total {
  font-size: 0.9em;
  .count {
    display: inline-block;
    margin-left: 0.3em;
    padding: 0 0.5em;
    font-size: 0.9em;
    font-weight: 700;
    color: $color-white;
    line-height: 1.3;
    border-radius: 50px;
    background-color: $color-green;
  }
}
.validateMessage {
  margin-bottom: 2px;
  padding: 2px 0;
  text-align: center;
  white-space: nowrap;
  color: $color-white;
  border-radius: 20px;
  background-color: $color-red;
}
</style>
